module.exports = __webpack_public_path__ + "images/track-week-bg.jpg?c706b";